import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faPhone } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Typography } from "@mui/material"
import React from "react"
import { SosButtonProps } from "./SosButton.interfaces"
import { StyledBox } from "./SosButton.styled"
import { useTranslation } from "react-i18next"

const SosButton: React.FC<SosButtonProps> = (props) => {
  const { t } = useTranslation()
  return (
    <Button variant="contained" color={"error"} style={{ padding: 5 }} {...props} href="tel:112">
      <StyledBox>
        <FontAwesomeIcon icon={faPhone as IconProp} size="sm" />
      </StyledBox>
      <Typography sx={{ marginRight: 1 }}>{t("crisismanagement.call_sos", "CALL SOS")}</Typography>
    </Button>
  )
}

export default SosButton
